export const nameValidationError = (name: string) => {
  const value = name.trim();
  return value.length < 2 || value.length > 100;
};
